import React from 'react';
import AnkeilerModal from '../_ankeiler-modal/component';
import { Button, Icon, TitleAndSubtitle } from 'audamatic-ui';
import AddToCartButton  from '@components/ui_add-to-cart-button/component';
import StockCounter from '@components/stock_counter/component';
import Text from '@components/ui_text/component';
import PropTypes from 'prop-types';
import './styles.scss';

const AnkeilerMinimalList = (props) => {
  const { product, store, items, index } = props;

  const {
    name,
    tagname,
    ean,
    sku,
    type,
    language,
    stockLevel,
    rightOfReturn,
    isCBProduct,
    isCBBuitenlandsProduct,
  } = product;

  const arrayOfSubtitleElements = [tagname, ean || sku, type];
  const subtitle = arrayOfSubtitleElements.filter(Boolean).join(' | ');

  const openAnkeilerModal = () => {
    store.modal.openModal('popup', 'center', {
      component: <AnkeilerModal
        product={product}
        store={store}
        items={items}
        index={index}
      />,
    });
  };

  return (
    <div className="ankeiler-minimal-list" >
      <div className="clickable" onClick={() => openAnkeilerModal()}>
        <div className="title">
          <Button
            variant="tertiary"
            size="medium"
            iconLeft={<Icon name="Search" size="sm"/>}
          />
          <TitleAndSubtitle
            title={name}
            subtitle={subtitle}
          />
        </div>
        <ul className="meta">
          <li>{language}</li>
          {stockLevel > 0 && !isCBProduct && !isCBBuitenlandsProduct && (
            <li>
              <StockCounter stockCount={stockLevel} />
            </li>
          )}
          <li>
            <Text>orders.ror.abbreviation</Text>:&nbsp;
            {!!rightOfReturn ? (
              <Text>product.metadata.rightofreturn.yes</Text>
            ) : (
              <Text>product.metadata.rightofreturn.no</Text>
            )}
          </li>
        </ul>
      </div>
      <div className="flex-wrap">
        <AddToCartButton
          store={store}
          product={product}
          showQuantity={true}
          hideText={true}
        />
      </div>
    </div>
  );
};

AnkeilerMinimalList.propTypes = {
  product: PropTypes.object,
  store: PropTypes.object,
  items: PropTypes.array,
  index: PropTypes.number,
};
export default AnkeilerMinimalList;
